module.exports = __webpack_public_path__ + "media/images/ui-onboard/unique-widgets-05ef78308edc5255a0a14a023a5ecf88.svg";